import _ from 'lodash'
import {QUOTED, START} from 'pu-data/QuoteSteps';

const state = {
  quoteStep: START,
  parameters: {
    carrier_thickness: '6 mm',
  },
};

if (Spree.quote) {
  state.quoteStep = QUOTED;
  state.quote = Spree.quote;
}

if (Spree.quote_parameters) {
  state.parameters = Object.assign({}, state.parameters, Spree.quote_parameters);
  // state.parameters = Spree.quote_parameters;
}

export default state;
